<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.25 5.25C2.25 4.42157 2.92157 3.75 3.75 3.75H8.14286H8.38589L8.58274 3.89254L11.493 6H20.25C21.0784 6 21.75 6.67157 21.75 7.5V19.5C21.75 20.3284 21.0784 21 20.25 21H3.75C2.92157 21 2.25 20.3284 2.25 19.5L2.25 5.25ZM7.89982 5.25L3.75 5.25V19.5H20.25V7.5H11.25H11.007L10.8101 7.35746L7.89982 5.25Z" fill="currentColor"/>
  </svg>
</template>
    